module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/people-2171e4be3d56e76ff5793b5b0053d129.svg";